import { CoreBox } from '@youscience/core';

import ReducedViewIcon from '@images/reduced-view.svg?react';
import LinearViewIcon from '@images/linear-view.svg?react';

import {
  sxStyles,
  StyledSwitchReducedButton,
  StyledSwitchLinearButton,
} from '@components/CardViewSwitcher/CardViewSwitcher.styles';

interface CardViewSwitcherProps {
  isLinearView: boolean;
  setIsLinearView: (status: boolean) => void;
}

export const CardViewSwitcher = (props: CardViewSwitcherProps) => {
  const { isLinearView, setIsLinearView } = props;

  const handleReducedView = () => {
    setIsLinearView(false);
  };

  const handleLinearView = () => {
    setIsLinearView(true);
  };

  return (
    <CoreBox sx={sxStyles.switcherWrap}>
      <StyledSwitchReducedButton isActive={!isLinearView} onClick={handleReducedView} data-testid="defaultViewIcon">
        <ReducedViewIcon />
      </StyledSwitchReducedButton>

      <StyledSwitchLinearButton isActive={isLinearView} onClick={handleLinearView} data-testid="linearViewIcon">
        <LinearViewIcon />
      </StyledSwitchLinearButton>
    </CoreBox>
  );
};
